import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import HeroSection from './components/HeroSection';
import ManifestoSection from './components/ManifestoSection';
import VideoSection from './components/VideoSection';
import DualitySection from './components/DualitySection';
import HomeFooter from './components/HomeFooter';

export default function Home() {
  useScrollAnimation();

  return (
    <main className="bg-black min-h-screen">
      <HeroSection />
      <ManifestoSection />
      <VideoSection />
      <DualitySection />
      <HomeFooter />
    </main>
  );
}